"use strict";

exports.__esModule = true;
exports.default = void 0;
const schema = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  Name: {
    displayName: 'Name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  }
};
var _default = exports.default = schema;
module.exports = exports.default;